import React, { useState } from 'react';
import {
  ExclamationTriangleIcon,
  XMarkIcon,
} from '@heroicons/react/24/outline';
import { ContextUsage, useChatStore } from '../../store/chatStore';

import { useTranslation } from 'react-i18next';

interface ContextUsageBannerProps {
  contextUsage?: ContextUsage;
  className?: string;
}

export const ContextUsageBanner: React.FC<ContextUsageBannerProps> = ({
  contextUsage,
  className = '',
}) => {
  const { t } = useTranslation('pleri/chat');
  const [isDismissed, setIsDismissed] = useState(false);
  const createConversation = useChatStore((state) => state.createConversation);

  if (!contextUsage || contextUsage.percentage < 90 || isDismissed) {
    return null;
  }

  const handleCreateNewConversation = () => {
    createConversation();
  };

  return (
    <div className={`mx-auto w-full max-w-3xl ${className}`}>
      <div className="rounded-lg border border-yellow-200 bg-yellow-50 px-4 py-3 dark:border-yellow-700 dark:bg-yellow-950">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="flex-shrink-0">
              <ExclamationTriangleIcon className="h-5 w-5 text-yellow-400" />
            </div>
            <div>
              <h3 className="text-sm font-medium text-yellow-800">
                {t('aNewChatWillHelpKeepResponses')}
              </h3>
              <p className="text-sm text-yellow-700">
                {t('yourConversationIsGettingLongStartingFresh')}
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={handleCreateNewConversation}
              className="rounded-md bg-yellow-100 px-3 py-1.5 text-sm font-medium text-yellow-800 transition-colors hover:bg-yellow-200 focus:ring-2 focus:ring-yellow-500 focus:ring-offset-2 focus:outline-none dark:bg-yellow-900"
            >
              {t('startNewChat')}
            </button>
            <button
              onClick={() => setIsDismissed(true)}
              className="rounded-md p-1.5 text-yellow-600 transition-colors hover:bg-yellow-100 focus:ring-2 focus:ring-yellow-500 focus:ring-offset-2 focus:outline-none"
              title={t('dismiss')}
            >
              <XMarkIcon className="h-4 w-4" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
